import notificationsModule from '@/store/modules/notifications';

import { createNotificationEmitter } from './firebase';

export const initNotifications = () => {
    createNotificationEmitter()
        .subscribeToNotification(notificationsModule.showWithTimeout);
}
